import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { UtilityService } from '../../../services/utility.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { WebClientService } from '../../../services/webclient-settings.service';
/**
 * Change Mobile Component
 */
let ChangeMobileComponent = class ChangeMobileComponent {
    constructor(httpClient, checker, sanitizer, themeService, webSettingsService, utility) {
        this.httpClient = httpClient;
        this.checker = checker;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.utility = utility;
        this.phone = {};
        this.sms = {};
        this.phoneError = false;
        this.showPhoneErrorMessage = false;
        this.sendTokenErrorMessage = false;
        this.confirmTokenErrorMessage = false;
        this.activeState = 'mobile';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.phoneUniqueError = false;
        this.validateUniquePhone = 1;
        this.invalidPassword = false;
        this.incorrectSmsTokenMessage = 'INCORRECT_SMS_TOKEN';
        this.incorrectEmailTokenMessage = 'INCORRECT_EMAIL_TOKEN';
        this.showIncorrectSmsTokenError = false;
        this.showIncorrectEmailTokenError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
        this.validateUniquePhone = this.webSettingsService.getWebSetting('ACCOUNT.VALIDATE_UNIQUE_PHONE');
    }
    ngOnInit() {
    }
    resetNumber() {
        this.checkPhone();
        this.showPhoneErrorMessage = false;
        this.phoneUniqueError = false;
        this.invalidPassword = false;
        this.sendTokenErrorMessage = false;
        if (!this.phoneError) {
            this.utility.goDisableSendSmsButton();
            this.httpClient.post('user/changemobilenumber', this.phone).subscribe((result) => {
                this.activeState = 'enterCode';
            }, (error) => {
                if (error.error[0] == 'PHONE_NUMBER_IS_NOT_UNIQUE') {
                    this.phoneUniqueError = true;
                }
                else if (error.error[0] === 'INVALID_PASSWORD') {
                    this.invalidPassword = true;
                }
                else {
                    this.sendTokenErrorMessage = true;
                }
                this.utility.resetTimer();
            });
        }
        else {
            this.showPhoneErrorMessage = true;
        }
    }
    checkPhone() {
        this.phoneError = !this.checker.checkPhone(this.phone.new_number);
        this.showPhoneErrorMessage = this.phoneError;
    }
    enterToken() {
        this.showIncorrectSmsTokenError = false;
        this.showIncorrectEmailTokenError = false;
        this.httpClient.post('user/insertresetnumbertoken', this.sms).subscribe((result) => {
            this.activeState = 'success';
        }, (error) => {
            if (error.error.message.includes(this.incorrectSmsTokenMessage)) {
                this.showIncorrectSmsTokenError = true;
            }
            if (error.error.message.includes(this.incorrectEmailTokenMessage)) {
                this.showIncorrectEmailTokenError = true;
            }
        });
    }
};
ChangeMobileComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: UtilityService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: UtilityService }
];
ChangeMobileComponent = __decorate([
    Component({
        selector: 'ecd-change-mobile',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./change-mobile.component.html")).default
    })
], ChangeMobileComponent);
export { ChangeMobileComponent };
